import React, { useEffect, useState } from 'react';
import { Redirect, Route, useLocation } from 'react-router-dom';
import { saveAuthTokenLocalStorage } from '../../helpers/LocalStorageHelper';

function AuthRedirect({ ...options }) {
  const { search } = useLocation();
  const authToken = new URLSearchParams(search).get('token');
  const opportunityId = new URLSearchParams(search).get('opportunityId');
  const redirectTo = new URLSearchParams(search).get('redirectTo');
  const [tokenSaved, setTokenSaved] = useState(false);

  useEffect(() => {
    if (authToken) {
      console.log('🔑 AuthRedirect: Saving token to localStorage:', authToken);
      saveAuthTokenLocalStorage({ authToken });
      setTokenSaved(true);
    } else {
      console.error('❌ AuthRedirect: No token found in URL');
      // If no token, still allow redirect (user might already be logged in)
      setTokenSaved(true);
    }
  }, [authToken]);

  // Wait for token to be saved before redirecting
  if (!tokenSaved) {
    return <div>Loading...</div>;
  }

  return (
    <Route {...options}>
      {opportunityId ? (
        <Redirect to={`/opportunities/opportunityDetails/${opportunityId}`} />
      ) : (
        <Redirect to={redirectTo ? `/${redirectTo}` : '/dashboard'} />
      )}
    </Route>
  );
}

export default AuthRedirect;
